import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3de5ac0a = () => interopDefault(import('../pages/banner/index.vue' /* webpackChunkName: "pages/banner/index" */))
const _400eb6f5 = () => interopDefault(import('../pages/company/index.vue' /* webpackChunkName: "pages/company/index" */))
const _270ba302 = () => interopDefault(import('../pages/cruise-map.vue' /* webpackChunkName: "pages/cruise-map" */))
const _fe00e55c = () => interopDefault(import('../pages/cruise-map/composables/useCompanyList.js' /* webpackChunkName: "pages/cruise-map/composables/useCompanyList" */))
const _5fd9c246 = () => interopDefault(import('../pages/designer.vue' /* webpackChunkName: "pages/designer" */))
const _5cc0fc49 = () => interopDefault(import('../pages/designer/index.vue' /* webpackChunkName: "pages/designer/index" */))
const _02cff937 = () => interopDefault(import('../pages/designer/customer.vue' /* webpackChunkName: "pages/designer/customer" */))
const _1172786c = () => interopDefault(import('../pages/designer/customization.vue' /* webpackChunkName: "pages/designer/customization" */))
const _aa1938a8 = () => interopDefault(import('../pages/designer/mine.vue' /* webpackChunkName: "pages/designer/mine" */))
const _5f9ce7ca = () => interopDefault(import('../pages/designer/offiaccount.vue' /* webpackChunkName: "pages/designer/offiaccount" */))
const _be146412 = () => interopDefault(import('../pages/designer/tabbar.vue' /* webpackChunkName: "pages/designer/tabbar" */))
const _406126c6 = () => interopDefault(import('../pages/destination/index.vue' /* webpackChunkName: "pages/destination/index" */))
const _27011863 = () => interopDefault(import('../pages/feedback/index.vue' /* webpackChunkName: "pages/feedback/index" */))
const _2d942d6a = () => interopDefault(import('../pages/harbor/index.vue' /* webpackChunkName: "pages/harbor/index" */))
const _ca0b401e = () => interopDefault(import('../pages/helpcenter.vue' /* webpackChunkName: "pages/helpcenter" */))
const _48016db4 = () => interopDefault(import('../pages/helpcenter/index.vue' /* webpackChunkName: "pages/helpcenter/index" */))
const _1ca8f39c = () => interopDefault(import('../pages/helpcenter/help-info.vue' /* webpackChunkName: "pages/helpcenter/help-info" */))
const _11f5fe67 = () => interopDefault(import('../pages/helpcenter/question-answer.vue' /* webpackChunkName: "pages/helpcenter/question-answer" */))
const _7f72a452 = () => interopDefault(import('../pages/introduce/index.vue' /* webpackChunkName: "pages/introduce/index" */))
const _216e59ef = () => interopDefault(import('../pages/merchant-center.vue' /* webpackChunkName: "pages/merchant-center" */))
const _65a61b83 = () => interopDefault(import('../pages/order.vue' /* webpackChunkName: "pages/order" */))
const _7f02b3c6 = () => interopDefault(import('../pages/order/index.vue' /* webpackChunkName: "pages/order/index" */))
const _11e3e184 = () => interopDefault(import('../pages/order/confirmationsheet.vue' /* webpackChunkName: "pages/order/confirmationsheet" */))
const _7767bc76 = () => interopDefault(import('../pages/order/touristinformation.vue' /* webpackChunkName: "pages/order/touristinformation" */))
const _516d97be = () => interopDefault(import('../pages/order/platform/cruiseship.vue' /* webpackChunkName: "pages/order/platform/cruiseship" */))
const _864aeff8 = () => interopDefault(import('../pages/order/platform/line.vue' /* webpackChunkName: "pages/order/platform/line" */))
const _93f3928a = () => interopDefault(import('../pages/order/store/cruiseship.vue' /* webpackChunkName: "pages/order/store/cruiseship" */))
const _b867f3c4 = () => interopDefault(import('../pages/order/store/line.vue' /* webpackChunkName: "pages/order/store/line" */))
const _7a18342e = () => interopDefault(import('../pages/resource.vue' /* webpackChunkName: "pages/resource" */))
const _a5e6cca8 = () => interopDefault(import('../pages/resource/index.vue' /* webpackChunkName: "pages/resource/index" */))
const _57cc4607 = () => interopDefault(import('../pages/resource/invoice.vue' /* webpackChunkName: "pages/resource/invoice" */))
const _6dd0296c = () => interopDefault(import('../pages/resource/invoice/index.vue' /* webpackChunkName: "pages/resource/invoice/index" */))
const _c154ed74 = () => interopDefault(import('../pages/resource/invoice/invoice-apply.vue' /* webpackChunkName: "pages/resource/invoice/invoice-apply" */))
const _0ae2c829 = () => interopDefault(import('../pages/resource/invoice/invoice-detail.vue' /* webpackChunkName: "pages/resource/invoice/invoice-detail" */))
const _89d1d53e = () => interopDefault(import('../pages/resource/invoice/invoice-payable-list.vue' /* webpackChunkName: "pages/resource/invoice/invoice-payable-list" */))
const _74bc40ee = () => interopDefault(import('../pages/resource/invoice/invoice-uninvoiced-order.vue' /* webpackChunkName: "pages/resource/invoice/invoice-uninvoiced-order" */))
const _70deda80 = () => interopDefault(import('../pages/resource/material/index.vue' /* webpackChunkName: "pages/resource/material/index" */))
const _4207aa8c = () => interopDefault(import('../pages/resource/product/index.vue' /* webpackChunkName: "pages/resource/product/index" */))
const _348dbb0c = () => interopDefault(import('../pages/resource/shop.vue' /* webpackChunkName: "pages/resource/shop" */))
const _daa66ee2 = () => interopDefault(import('../pages/resource/shop/index.vue' /* webpackChunkName: "pages/resource/shop/index" */))
const _5d6a9142 = () => interopDefault(import('../pages/resource/shop/agent.vue' /* webpackChunkName: "pages/resource/shop/agent" */))
const _44a19e45 = () => interopDefault(import('../pages/resource/shop/agent/index.vue' /* webpackChunkName: "pages/resource/shop/agent/index" */))
const _5820ec6c = () => interopDefault(import('../pages/resource/shop/agent/pending.vue' /* webpackChunkName: "pages/resource/shop/agent/pending" */))
const _5c2a763c = () => interopDefault(import('../pages/resource/shop/income.vue' /* webpackChunkName: "pages/resource/shop/income" */))
const _3358e6af = () => interopDefault(import('../pages/resource/shop/productmanagement.vue' /* webpackChunkName: "pages/resource/shop/productmanagement" */))
const _0962945d = () => interopDefault(import('../pages/resource/shop/withdraw.vue' /* webpackChunkName: "pages/resource/shop/withdraw" */))
const _1d9d8b66 = () => interopDefault(import('../pages/resource/study/index.vue' /* webpackChunkName: "pages/resource/study/index" */))
const _b3c73790 = () => interopDefault(import('../pages/resource/transaction.vue' /* webpackChunkName: "pages/resource/transaction" */))
const _0ec6d076 = () => interopDefault(import('../pages/resource/transaction/list.vue' /* webpackChunkName: "pages/resource/transaction/list" */))
const _0e91d9ce = () => interopDefault(import('../pages/resource/transaction/recharge.vue' /* webpackChunkName: "pages/resource/transaction/recharge" */))
const _58614dc8 = () => interopDefault(import('../pages/resource/transaction/withdrawal.vue' /* webpackChunkName: "pages/resource/transaction/withdrawal" */))
const _e7a90916 = () => interopDefault(import('../pages/resource/messagecenter/order.vue' /* webpackChunkName: "pages/resource/messagecenter/order" */))
const _085beb88 = () => interopDefault(import('../pages/resource/messagecenter/store.vue' /* webpackChunkName: "pages/resource/messagecenter/store" */))
const _6e045fca = () => interopDefault(import('../pages/resource/official-accounts/left-config.vue' /* webpackChunkName: "pages/resource/official-accounts/left-config" */))
const _16274be7 = () => interopDefault(import('../pages/resource/official-accounts/messageEditor.vue' /* webpackChunkName: "pages/resource/official-accounts/messageEditor" */))
const _721aae14 = () => interopDefault(import('../pages/resource/official-accounts/officialaccountmenu.vue' /* webpackChunkName: "pages/resource/official-accounts/officialaccountmenu" */))
const _3cebc2d0 = () => interopDefault(import('../pages/resource/official-accounts/right-config.vue' /* webpackChunkName: "pages/resource/official-accounts/right-config" */))
const _50c494ac = () => interopDefault(import('../pages/resource/order/platform.vue' /* webpackChunkName: "pages/resource/order/platform" */))
const _b3a6598c = () => interopDefault(import('../pages/resource/order/store.vue' /* webpackChunkName: "pages/resource/order/store" */))
const _6430da1c = () => interopDefault(import('../pages/resource/product/collectionlist.vue' /* webpackChunkName: "pages/resource/product/collectionlist" */))
const _2cc6a22d = () => interopDefault(import('../pages/resource/tools/message.vue' /* webpackChunkName: "pages/resource/tools/message" */))
const _120a12f0 = () => interopDefault(import('../pages/resource/tools/message/index.vue' /* webpackChunkName: "pages/resource/tools/message/index" */))
const _1fac1e23 = () => interopDefault(import('../pages/resource/tools/message/create-temp.vue' /* webpackChunkName: "pages/resource/tools/message/create-temp" */))
const _d80f243c = () => interopDefault(import('../pages/resource/tools/message/log.vue' /* webpackChunkName: "pages/resource/tools/message/log" */))
const _7d07543f = () => interopDefault(import('../pages/resource/tools/message/masstexting.vue' /* webpackChunkName: "pages/resource/tools/message/masstexting" */))
const _9d35010e = () => interopDefault(import('../pages/resource/tools/message/recharge.vue' /* webpackChunkName: "pages/resource/tools/message/recharge" */))
const _9d65024a = () => interopDefault(import('../pages/resource/tools/qrcode/index.vue' /* webpackChunkName: "pages/resource/tools/qrcode/index" */))
const _4c7ba492 = () => interopDefault(import('../pages/resource/usercenter/companyinfo.vue' /* webpackChunkName: "pages/resource/usercenter/companyinfo" */))
const _012a44e2 = () => interopDefault(import('../pages/resource/usercenter/coupon.vue' /* webpackChunkName: "pages/resource/usercenter/coupon" */))
const _059cb18a = () => interopDefault(import('../pages/resource/usercenter/staffmanagement.vue' /* webpackChunkName: "pages/resource/usercenter/staffmanagement" */))
const _fc1cb2bc = () => interopDefault(import('../pages/resource/usercenter/userinfo.vue' /* webpackChunkName: "pages/resource/usercenter/userinfo" */))
const _f8383662 = () => interopDefault(import('../pages/resource/product/-list/cruise.vue' /* webpackChunkName: "pages/resource/product/-list/cruise" */))
const _bfd2b17a = () => interopDefault(import('../pages/resource/tools/qrcode/create.vue' /* webpackChunkName: "pages/resource/tools/qrcode/create" */))
const _0b62417a = () => interopDefault(import('../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _3b10c7f1 = () => interopDefault(import('../pages/settled/index.vue' /* webpackChunkName: "pages/settled/index" */))
const _7fac9740 = () => interopDefault(import('../pages/ShopQrFlow.vue' /* webpackChunkName: "pages/ShopQrFlow" */))
const _c2326092 = () => interopDefault(import('../pages/theme-cruise/index.vue' /* webpackChunkName: "pages/theme-cruise/index" */))
const _d7b8ee38 = () => interopDefault(import('../pages/topic.vue' /* webpackChunkName: "pages/topic" */))
const _470a1f9e = () => interopDefault(import('../pages/topic/ct-jsrcdj.vue' /* webpackChunkName: "pages/topic/ct-jsrcdj" */))
const _4a96e831 = () => interopDefault(import('../pages/topic/rebate-policy.vue' /* webpackChunkName: "pages/topic/rebate-policy" */))
const _57be98a4 = () => interopDefault(import('../pages/topic/shop-tool.vue' /* webpackChunkName: "pages/topic/shop-tool" */))
const _61190b6d = () => interopDefault(import('../pages/topic/topic-temp.vue' /* webpackChunkName: "pages/topic/topic-temp" */))
const _8c279f5c = () => interopDefault(import('../pages/topic/2021/CenturyLegend-explorer.vue' /* webpackChunkName: "pages/topic/2021/CenturyLegend-explorer" */))
const _0df3bca5 = () => interopDefault(import('../pages/topic/2021/yangzi-explorer.vue' /* webpackChunkName: "pages/topic/2021/yangzi-explorer" */))
const _3735af15 = () => interopDefault(import('../pages/topic/2022/aden/index.vue' /* webpackChunkName: "pages/topic/2022/aden/index" */))
const _29b4a56c = () => interopDefault(import('../pages/topic/202208/aden.vue' /* webpackChunkName: "pages/topic/202208/aden" */))
const _7c03ff74 = () => interopDefault(import('../pages/topic/202208/hulunbuir.vue' /* webpackChunkName: "pages/topic/202208/hulunbuir" */))
const _efb55286 = () => interopDefault(import('../pages/topic/202208/secretlandscape.vue' /* webpackChunkName: "pages/topic/202208/secretlandscape" */))
const _3667d383 = () => interopDefault(import('../pages/topic/2023/antarctica.vue' /* webpackChunkName: "pages/topic/2023/antarctica" */))
const _a63dd796 = () => interopDefault(import('../pages/topic/2023/blue-dream.vue' /* webpackChunkName: "pages/topic/2023/blue-dream" */))
const _2598bd25 = () => interopDefault(import('../pages/topic/2023/jsrcdj.vue' /* webpackChunkName: "pages/topic/2023/jsrcdj" */))
const _5eb58182 = () => interopDefault(import('../pages/topic/2023/spectrum-of-the-seas.vue' /* webpackChunkName: "pages/topic/2023/spectrum-of-the-seas" */))
const _783680a6 = () => interopDefault(import('../pages/user.vue' /* webpackChunkName: "pages/user" */))
const _4143772a = () => interopDefault(import('../pages/company/brand.vue' /* webpackChunkName: "pages/company/brand" */))
const _110c3f72 = () => interopDefault(import('../pages/company/cruise-company.vue' /* webpackChunkName: "pages/company/cruise-company" */))
const _7102c279 = () => interopDefault(import('../pages/company/cruise-list.vue' /* webpackChunkName: "pages/company/cruise-list" */))
const _18e776f3 = () => interopDefault(import('../pages/company/cruise-notice.vue' /* webpackChunkName: "pages/company/cruise-notice" */))
const _1dd72b6c = () => interopDefault(import('../pages/company/info-recommend.vue' /* webpackChunkName: "pages/company/info-recommend" */))
const _c7491be2 = () => interopDefault(import('../pages/company/information.vue' /* webpackChunkName: "pages/company/information" */))
const _2f2fdb6a = () => interopDefault(import('../pages/company/list.vue' /* webpackChunkName: "pages/company/list" */))
const _4a80f81d = () => interopDefault(import('../pages/company/new-ranking-basis.vue' /* webpackChunkName: "pages/company/new-ranking-basis" */))
const _2a008584 = () => interopDefault(import('../pages/company/old-brand.vue' /* webpackChunkName: "pages/company/old-brand" */))
const _671e6dfe = () => interopDefault(import('../pages/company/original-home.vue' /* webpackChunkName: "pages/company/original-home" */))
const _013f8c95 = () => interopDefault(import('../pages/company/trade-home.vue' /* webpackChunkName: "pages/company/trade-home" */))
const _35d00ae4 = () => interopDefault(import('../pages/customer/list.vue' /* webpackChunkName: "pages/customer/list" */))
const _7d0fe45a = () => interopDefault(import('../pages/destination/list.vue' /* webpackChunkName: "pages/destination/list" */))
const _42e03383 = () => interopDefault(import('../pages/harbor/city.vue' /* webpackChunkName: "pages/harbor/city" */))
const _a19289f2 = () => interopDefault(import('../pages/harbor/product.vue' /* webpackChunkName: "pages/harbor/product" */))
const _d61471ea = () => interopDefault(import('../pages/product/cruise-calendar.vue' /* webpackChunkName: "pages/product/cruise-calendar" */))
const _ab03f3ea = () => interopDefault(import('../pages/product/custom-travel.vue' /* webpackChunkName: "pages/product/custom-travel" */))
const _57598a4d = () => interopDefault(import('../pages/product/end-order-discount.vue' /* webpackChunkName: "pages/product/end-order-discount" */))
const _350e86a9 = () => interopDefault(import('../pages/product/holiday-route.vue' /* webpackChunkName: "pages/product/holiday-route" */))
const _e1c1d04a = () => interopDefault(import('../pages/product/vacation/index.vue' /* webpackChunkName: "pages/product/vacation/index" */))
const _961d3d64 = () => interopDefault(import('../pages/settled/process.vue' /* webpackChunkName: "pages/settled/process" */))
const _1bab75f2 = () => interopDefault(import('../pages/company/cruise/century.vue' /* webpackChunkName: "pages/company/cruise/century" */))
const _79d19d9a = () => interopDefault(import('../pages/company/cruise/decknavigation.vue' /* webpackChunkName: "pages/company/cruise/decknavigation" */))
const _82bd5af6 = () => interopDefault(import('../pages/company/cruise/gallery.vue' /* webpackChunkName: "pages/company/cruise/gallery" */))
const _d128fcdc = () => interopDefault(import('../pages/company/cruise/location.vue' /* webpackChunkName: "pages/company/cruise/location" */))
const _4beb2470 = () => interopDefault(import('../pages/feedback/components/list.vue' /* webpackChunkName: "pages/feedback/components/list" */))
const _47ddf54a = () => interopDefault(import('../pages/feedback/components/suggest.vue' /* webpackChunkName: "pages/feedback/components/suggest" */))
const _15ca6bea = () => interopDefault(import('../pages/product/automation/foreign-cruise-search.vue' /* webpackChunkName: "pages/product/automation/foreign-cruise-search" */))
const _75f52234 = () => interopDefault(import('../pages/product/automation/placeorder.vue' /* webpackChunkName: "pages/product/automation/placeorder" */))
const _5eb79c92 = () => interopDefault(import('../pages/product/automation/placeorder/index.vue' /* webpackChunkName: "pages/product/automation/placeorder/index" */))
const _47198d26 = () => interopDefault(import('../pages/product/automation/placeorder/select-floor.vue' /* webpackChunkName: "pages/product/automation/placeorder/select-floor" */))
const _3baa6906 = () => interopDefault(import('../pages/product/automation/placeorder/select-room-type.vue' /* webpackChunkName: "pages/product/automation/placeorder/select-room-type" */))
const _11c5ada6 = () => interopDefault(import('../pages/product/automation/placeorder/visitor-fill.vue' /* webpackChunkName: "pages/product/automation/placeorder/visitor-fill" */))
const _45a93a49 = () => interopDefault(import('../pages/product/automation/requirements-agreements.vue' /* webpackChunkName: "pages/product/automation/requirements-agreements" */))
const _323a234c = () => interopDefault(import('../pages/product/cruise/booking.vue' /* webpackChunkName: "pages/product/cruise/booking" */))
const _3af70ced = () => interopDefault(import('../pages/product/cruise/list.vue' /* webpackChunkName: "pages/product/cruise/list" */))
const _a0ee8ca0 = () => interopDefault(import('../pages/product/cruise/pre-booking.vue' /* webpackChunkName: "pages/product/cruise/pre-booking" */))
const _2a1606b6 = () => interopDefault(import('../pages/product/vacation/list.vue' /* webpackChunkName: "pages/product/vacation/list" */))
const _572fa33c = () => interopDefault(import('../pages/product/vacation/placeholder.vue' /* webpackChunkName: "pages/product/vacation/placeholder" */))
const _5ba82af8 = () => interopDefault(import('../pages/product/vacation/pre-booking.vue' /* webpackChunkName: "pages/product/vacation/pre-booking" */))
const _4cdb5b07 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _42edf750 = () => interopDefault(import('../pages/company/article/_articleId.vue' /* webpackChunkName: "pages/company/article/_articleId" */))
const _0ebe8822 = () => interopDefault(import('../pages/company/cruise/_cruiseId.vue' /* webpackChunkName: "pages/company/cruise/_cruiseId" */))
const _32502c2a = () => interopDefault(import('../pages/partner/content/_index.vue' /* webpackChunkName: "pages/partner/content/_index" */))
const _43e4b41e = () => interopDefault(import('../pages/product/automation/_productNo.vue' /* webpackChunkName: "pages/product/automation/_productNo" */))
const _10fa5720 = () => interopDefault(import('../pages/product/cruise/_productNo.vue' /* webpackChunkName: "pages/product/cruise/_productNo" */))
const _06039cd8 = () => interopDefault(import('../pages/product/vacation/_productNo.vue' /* webpackChunkName: "pages/product/vacation/_productNo" */))
const _3ade926c = () => interopDefault(import('../pages/approval/_approvalId.vue' /* webpackChunkName: "pages/approval/_approvalId" */))
const _07f92d66 = () => interopDefault(import('../pages/company/_companyId.vue' /* webpackChunkName: "pages/company/_companyId" */))
const _476e0065 = () => interopDefault(import('../pages/cruise-ranking/_basis.vue' /* webpackChunkName: "pages/cruise-ranking/_basis" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/banner",
    component: _3de5ac0a,
    name: "banner"
  }, {
    path: "/company",
    component: _400eb6f5,
    name: "company"
  }, {
    path: "/cruise-map",
    component: _270ba302,
    name: "cruise-map",
    children: [{
      path: "composables/useCompanyList",
      component: _fe00e55c,
      name: "cruise-map-composables-useCompanyList"
    }]
  }, {
    path: "/designer",
    component: _5fd9c246,
    children: [{
      path: "",
      component: _5cc0fc49,
      name: "designer"
    }, {
      path: "customer",
      component: _02cff937,
      name: "designer-customer"
    }, {
      path: "customization",
      component: _1172786c,
      name: "designer-customization"
    }, {
      path: "mine",
      component: _aa1938a8,
      name: "designer-mine"
    }, {
      path: "offiaccount",
      component: _5f9ce7ca,
      name: "designer-offiaccount"
    }, {
      path: "tabbar",
      component: _be146412,
      name: "designer-tabbar"
    }]
  }, {
    path: "/destination",
    component: _406126c6,
    name: "destination"
  }, {
    path: "/feedback",
    component: _27011863,
    name: "feedback"
  }, {
    path: "/harbor",
    component: _2d942d6a,
    name: "harbor"
  }, {
    path: "/helpcenter",
    component: _ca0b401e,
    children: [{
      path: "",
      component: _48016db4,
      name: "helpcenter"
    }, {
      path: "help-info",
      component: _1ca8f39c,
      name: "helpcenter-help-info"
    }, {
      path: "question-answer",
      component: _11f5fe67,
      name: "helpcenter-question-answer"
    }]
  }, {
    path: "/introduce",
    component: _7f72a452,
    name: "introduce"
  }, {
    path: "/merchant-center",
    component: _216e59ef,
    name: "merchant-center"
  }, {
    path: "/order",
    component: _65a61b83,
    children: [{
      path: "",
      component: _7f02b3c6,
      name: "order"
    }, {
      path: "confirmationsheet",
      component: _11e3e184,
      name: "order-confirmationsheet"
    }, {
      path: "touristinformation",
      component: _7767bc76,
      name: "order-touristinformation"
    }, {
      path: "platform/cruiseship",
      component: _516d97be,
      name: "order-platform-cruiseship"
    }, {
      path: "platform/line",
      component: _864aeff8,
      name: "order-platform-line"
    }, {
      path: "store/cruiseship",
      component: _93f3928a,
      name: "order-store-cruiseship"
    }, {
      path: "store/line",
      component: _b867f3c4,
      name: "order-store-line"
    }]
  }, {
    path: "/resource",
    component: _7a18342e,
    children: [{
      path: "",
      component: _a5e6cca8,
      name: "resource"
    }, {
      path: "invoice",
      component: _57cc4607,
      children: [{
        path: "",
        component: _6dd0296c,
        name: "resource-invoice"
      }, {
        path: "invoice-apply",
        component: _c154ed74,
        name: "resource-invoice-invoice-apply"
      }, {
        path: "invoice-detail",
        component: _0ae2c829,
        name: "resource-invoice-invoice-detail"
      }, {
        path: "invoice-payable-list",
        component: _89d1d53e,
        name: "resource-invoice-invoice-payable-list"
      }, {
        path: "invoice-uninvoiced-order",
        component: _74bc40ee,
        name: "resource-invoice-invoice-uninvoiced-order"
      }]
    }, {
      path: "material",
      component: _70deda80,
      name: "resource-material"
    }, {
      path: "product",
      component: _4207aa8c,
      name: "resource-product"
    }, {
      path: "shop",
      component: _348dbb0c,
      children: [{
        path: "",
        component: _daa66ee2,
        name: "resource-shop"
      }, {
        path: "agent",
        component: _5d6a9142,
        children: [{
          path: "",
          component: _44a19e45,
          name: "resource-shop-agent"
        }, {
          path: "pending",
          component: _5820ec6c,
          name: "resource-shop-agent-pending"
        }]
      }, {
        path: "income",
        component: _5c2a763c,
        name: "resource-shop-income"
      }, {
        path: "productmanagement",
        component: _3358e6af,
        name: "resource-shop-productmanagement"
      }, {
        path: "withdraw",
        component: _0962945d,
        name: "resource-shop-withdraw"
      }]
    }, {
      path: "study",
      component: _1d9d8b66,
      name: "resource-study"
    }, {
      path: "transaction",
      component: _b3c73790,
      name: "resource-transaction",
      children: [{
        path: "list",
        component: _0ec6d076,
        name: "resource-transaction-list"
      }, {
        path: "recharge",
        component: _0e91d9ce,
        name: "resource-transaction-recharge"
      }, {
        path: "withdrawal",
        component: _58614dc8,
        name: "resource-transaction-withdrawal"
      }]
    }, {
      path: "messagecenter/order",
      component: _e7a90916,
      name: "resource-messagecenter-order"
    }, {
      path: "messagecenter/store",
      component: _085beb88,
      name: "resource-messagecenter-store"
    }, {
      path: "official-accounts/left-config",
      component: _6e045fca,
      name: "resource-official-accounts-left-config"
    }, {
      path: "official-accounts/messageEditor",
      component: _16274be7,
      name: "resource-official-accounts-messageEditor"
    }, {
      path: "official-accounts/officialaccountmenu",
      component: _721aae14,
      name: "resource-official-accounts-officialaccountmenu"
    }, {
      path: "official-accounts/right-config",
      component: _3cebc2d0,
      name: "resource-official-accounts-right-config"
    }, {
      path: "order/platform",
      component: _50c494ac,
      name: "resource-order-platform"
    }, {
      path: "order/store",
      component: _b3a6598c,
      name: "resource-order-store"
    }, {
      path: "product/collectionlist",
      component: _6430da1c,
      name: "resource-product-collectionlist"
    }, {
      path: "tools/message",
      component: _2cc6a22d,
      children: [{
        path: "",
        component: _120a12f0,
        name: "resource-tools-message"
      }, {
        path: "create-temp",
        component: _1fac1e23,
        name: "resource-tools-message-create-temp"
      }, {
        path: "log",
        component: _d80f243c,
        name: "resource-tools-message-log"
      }, {
        path: "masstexting",
        component: _7d07543f,
        name: "resource-tools-message-masstexting"
      }, {
        path: "recharge",
        component: _9d35010e,
        name: "resource-tools-message-recharge"
      }]
    }, {
      path: "tools/qrcode",
      component: _9d65024a,
      name: "resource-tools-qrcode"
    }, {
      path: "usercenter/companyinfo",
      component: _4c7ba492,
      name: "resource-usercenter-companyinfo"
    }, {
      path: "usercenter/coupon",
      component: _012a44e2,
      name: "resource-usercenter-coupon"
    }, {
      path: "usercenter/staffmanagement",
      component: _059cb18a,
      name: "resource-usercenter-staffmanagement"
    }, {
      path: "usercenter/userinfo",
      component: _fc1cb2bc,
      name: "resource-usercenter-userinfo"
    }, {
      path: "product/-list/cruise",
      component: _f8383662,
      name: "resource-product--list-cruise"
    }, {
      path: "tools/qrcode/create",
      component: _bfd2b17a,
      name: "resource-tools-qrcode-create"
    }]
  }, {
    path: "/search",
    component: _0b62417a,
    name: "search"
  }, {
    path: "/settled",
    component: _3b10c7f1,
    name: "settled"
  }, {
    path: "/ShopQrFlow",
    component: _7fac9740,
    name: "ShopQrFlow"
  }, {
    path: "/theme-cruise",
    component: _c2326092,
    name: "theme-cruise"
  }, {
    path: "/topic",
    component: _d7b8ee38,
    name: "topic",
    children: [{
      path: "ct-jsrcdj",
      component: _470a1f9e,
      name: "topic-ct-jsrcdj"
    }, {
      path: "rebate-policy",
      component: _4a96e831,
      name: "topic-rebate-policy"
    }, {
      path: "shop-tool",
      component: _57be98a4,
      name: "topic-shop-tool"
    }, {
      path: "topic-temp",
      component: _61190b6d,
      name: "topic-topic-temp"
    }, {
      path: "2021/CenturyLegend-explorer",
      component: _8c279f5c,
      name: "topic-2021-CenturyLegend-explorer"
    }, {
      path: "2021/yangzi-explorer",
      component: _0df3bca5,
      name: "topic-2021-yangzi-explorer"
    }, {
      path: "2022/aden",
      component: _3735af15,
      name: "topic-2022-aden"
    }, {
      path: "202208/aden",
      component: _29b4a56c,
      name: "topic-202208-aden"
    }, {
      path: "202208/hulunbuir",
      component: _7c03ff74,
      name: "topic-202208-hulunbuir"
    }, {
      path: "202208/secretlandscape",
      component: _efb55286,
      name: "topic-202208-secretlandscape"
    }, {
      path: "2023/antarctica",
      component: _3667d383,
      name: "topic-2023-antarctica"
    }, {
      path: "2023/blue-dream",
      component: _a63dd796,
      name: "topic-2023-blue-dream"
    }, {
      path: "2023/jsrcdj",
      component: _2598bd25,
      name: "topic-2023-jsrcdj"
    }, {
      path: "2023/spectrum-of-the-seas",
      component: _5eb58182,
      name: "topic-2023-spectrum-of-the-seas"
    }]
  }, {
    path: "/user",
    component: _783680a6,
    name: "user"
  }, {
    path: "/company/brand",
    component: _4143772a,
    name: "company-brand"
  }, {
    path: "/company/cruise-company",
    component: _110c3f72,
    name: "company-cruise-company"
  }, {
    path: "/company/cruise-list",
    component: _7102c279,
    name: "company-cruise-list"
  }, {
    path: "/company/cruise-notice",
    component: _18e776f3,
    name: "company-cruise-notice"
  }, {
    path: "/company/info-recommend",
    component: _1dd72b6c,
    name: "company-info-recommend"
  }, {
    path: "/company/information",
    component: _c7491be2,
    name: "company-information"
  }, {
    path: "/company/list",
    component: _2f2fdb6a,
    name: "company-list"
  }, {
    path: "/company/new-ranking-basis",
    component: _4a80f81d,
    name: "company-new-ranking-basis"
  }, {
    path: "/company/old-brand",
    component: _2a008584,
    name: "company-old-brand"
  }, {
    path: "/company/original-home",
    component: _671e6dfe,
    name: "company-original-home"
  }, {
    path: "/company/trade-home",
    component: _013f8c95,
    name: "company-trade-home"
  }, {
    path: "/customer/list",
    component: _35d00ae4,
    name: "customer-list"
  }, {
    path: "/destination/list",
    component: _7d0fe45a,
    name: "destination-list"
  }, {
    path: "/harbor/city",
    component: _42e03383,
    name: "harbor-city"
  }, {
    path: "/harbor/product",
    component: _a19289f2,
    name: "harbor-product"
  }, {
    path: "/product/cruise-calendar",
    component: _d61471ea,
    name: "product-cruise-calendar"
  }, {
    path: "/product/custom-travel",
    component: _ab03f3ea,
    name: "product-custom-travel"
  }, {
    path: "/product/end-order-discount",
    component: _57598a4d,
    name: "product-end-order-discount"
  }, {
    path: "/product/holiday-route",
    component: _350e86a9,
    name: "product-holiday-route"
  }, {
    path: "/product/vacation",
    component: _e1c1d04a,
    name: "product-vacation"
  }, {
    path: "/settled/process",
    component: _961d3d64,
    name: "settled-process"
  }, {
    path: "/company/cruise/century",
    component: _1bab75f2,
    name: "company-cruise-century"
  }, {
    path: "/company/cruise/decknavigation",
    component: _79d19d9a,
    name: "company-cruise-decknavigation"
  }, {
    path: "/company/cruise/gallery",
    component: _82bd5af6,
    name: "company-cruise-gallery"
  }, {
    path: "/company/cruise/location",
    component: _d128fcdc,
    name: "company-cruise-location"
  }, {
    path: "/feedback/components/list",
    component: _4beb2470,
    name: "feedback-components-list"
  }, {
    path: "/feedback/components/suggest",
    component: _47ddf54a,
    name: "feedback-components-suggest"
  }, {
    path: "/product/automation/foreign-cruise-search",
    component: _15ca6bea,
    name: "product-automation-foreign-cruise-search"
  }, {
    path: "/product/automation/placeorder",
    component: _75f52234,
    children: [{
      path: "",
      component: _5eb79c92,
      name: "product-automation-placeorder"
    }, {
      path: "select-floor",
      component: _47198d26,
      name: "product-automation-placeorder-select-floor"
    }, {
      path: "select-room-type",
      component: _3baa6906,
      name: "product-automation-placeorder-select-room-type"
    }, {
      path: "visitor-fill",
      component: _11c5ada6,
      name: "product-automation-placeorder-visitor-fill"
    }]
  }, {
    path: "/product/automation/requirements-agreements",
    component: _45a93a49,
    name: "product-automation-requirements-agreements"
  }, {
    path: "/product/cruise/booking",
    component: _323a234c,
    name: "product-cruise-booking"
  }, {
    path: "/product/cruise/list",
    component: _3af70ced,
    name: "product-cruise-list"
  }, {
    path: "/product/cruise/pre-booking",
    component: _a0ee8ca0,
    name: "product-cruise-pre-booking"
  }, {
    path: "/product/vacation/list",
    component: _2a1606b6,
    name: "product-vacation-list"
  }, {
    path: "/product/vacation/placeholder",
    component: _572fa33c,
    name: "product-vacation-placeholder"
  }, {
    path: "/product/vacation/pre-booking",
    component: _5ba82af8,
    name: "product-vacation-pre-booking"
  }, {
    path: "/",
    component: _4cdb5b07,
    name: "index"
  }, {
    path: "/company/article/:articleId?",
    component: _42edf750,
    name: "company-article-articleId"
  }, {
    path: "/company/cruise/:cruiseId?",
    component: _0ebe8822,
    name: "company-cruise-cruiseId"
  }, {
    path: "/partner/content/:index",
    component: _32502c2a,
    name: "partner-content"
  }, {
    path: "/product/automation/:productNo?",
    component: _43e4b41e,
    name: "product-automation-productNo"
  }, {
    path: "/product/cruise/:productNo?",
    component: _10fa5720,
    name: "product-cruise-productNo"
  }, {
    path: "/product/vacation/:productNo",
    component: _06039cd8,
    name: "product-vacation-productNo"
  }, {
    path: "/approval/:approvalId?",
    component: _3ade926c,
    name: "approval-approvalId"
  }, {
    path: "/company/:companyId",
    component: _07f92d66,
    name: "company-companyId"
  }, {
    path: "/cruise-ranking/:basis?",
    component: _476e0065,
    name: "cruise-ranking-basis"
  }, {
    path: "*",
    redirect: "/"
  }, {
    path: "/company/rank/:rankingBasis?",
    redirect: (to) => {
            const obj = {
              service: 'service_ratio',
              tonnage: 'tonnage',
              capacity: 'passenger_capacity',
              newest: 'first_flight_time'
            };
            return `/cruise-ranking/${obj[to.params.rankingBasis] || ''}`;
          },
    name: "company-rank-rankingBasis"
  }],

  parseQuery: function(...rest) {
  return require("qs").parse(...rest);
},
  stringifyQuery: function(query) {
  return require("qs").stringify(query, { addQueryPrefix: true });
},
  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
